import React from "react";
import CorrectSvg from "../assets/images/CorrectSvg";
import MemberVIPSvg from "../assets/images/MemberVIPSvg";

/**
 * Determine the membership status of a user.
 * @param {Object} user - user / record object
 * @returns {{ status: 'registering' | 'vip' | 'pro' | 'trial' | 'none', labelKey: string }}
 */
export const getMemberStatusInfo = (user) => {
    if (!user) {
        return { status: "none", labelKey: "No membership" };
    }

    // 1. Check registration completion
    if (!user.completedTS) {
        return {
            status: "registering",
            labelKey: "During Registration"
        };
    }

    const now = new Date();

    // 2. Check VIP / Super membership
    const isVipValid = Boolean(
        (user.memberType === "VIP" || user.memberType === "super") 
        // &&
        // (!user.lastVIP?.endedTS || new Date(user.lastVIP.endedTS) > now)
    // ) || Boolean(
    //     user.lastVIP?.endedTS && new Date(user.lastVIP.endedTS) > now
    );

    if (isVipValid) {
        return {
            status: "vip",
            labelKey: "Super membership"
        };
    }

    // 3. Check Pro / Normal membership
    const isProValid = Boolean(
        user.memberType === "pro" 
        // &&
    //     (!user.lastPro?.endedTS || new Date(user.lastPro.endedTS) > now)
    // ) || Boolean(
    //     user.lastPro?.endedTS && new Date(user.lastPro.endedTS) > now
    );

    if (isProValid) {
        return {
            status: "pro",
            labelKey: "Normal membership"
        };
    }

    // 4. Check Free Trial
    const isTrial = user.memberType === "trial" || user.subscription?.plan === "trial" || user.subscription?.plan === "free";
    if (isTrial) {
        const trialEnded = user.subscription?.endedTS || user.expiredTS;
        if (!trialEnded || new Date(trialEnded) > now) {
            return {
                status: "trial",
                labelKey: "During Free Trial"
            };
        }
    }

    // 5. Expired membership / trial or no membership
    return {
        status: "none",
        labelKey: "No membership"
    };
};

/**
 * Render a standardized badge / status element for the user's membership status.
 * @param {Object} user - user / record object
 * @param {Function} t - translation function
 * @param {Object} options - custom styling options
 */
export const renderMemberStatusBadge = (user, t, options = {}) => {
    const statusInfo = getMemberStatusInfo(user);

    switch (statusInfo.status) {
        case "vip":
            return (
                <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", ...options.containerStyle }}>
                    <MemberVIPSvg />
                    {options.showText && <span className="text-capitalize" style={options.textStyle}>{t(statusInfo.labelKey)}</span>}
                </div>
            );
        case "pro":
            return (
                <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", ...options.containerStyle }}>
                    <CorrectSvg />
                    <span className="text-capitalize" style={options.textStyle}>{t(statusInfo.labelKey)}</span>
                </div>
            );
        case "trial":
            return (
                <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", ...options.containerStyle }}>
                    <CorrectSvg />
                    <span className="text-capitalize" style={options.textStyle}>{t(statusInfo.labelKey)}</span>
                </div>
            );
        case "registering":
            return (
                <div style={{ display: "inline-flex", alignItems: "center", ...options.containerStyle }}>
                    <span className="text-capitalize" style={options.textStyle}>{t(statusInfo.labelKey)}</span>
                </div>
            );
        case "none":
        default:
            return (
                <div style={{ display: "inline-flex", alignItems: "center", ...options.containerStyle }}>
                    <span className="text-capitalize" style={options.textStyle}>{t(statusInfo.labelKey)}</span>
                </div>
            );
    }
};

/**
 * Get plan display label key for subscription history.
 * @param {string} plan - "free" | "trial" | "pro" | "super" | "VIP"
 * @returns {string} Translation key
 */
export const getSubscriptionPlanLabelKey = (plan) => {
    switch (plan?.toLowerCase()) {
        case "free":
        case "trial":
            return "Free trial";
        case "pro":
            return "Normal membership";
        case "super":
        case "vip":
            return "Super membership";
        default:
            return plan || "Normal membership";
    }
};
